import {API_HOST_NAME} from "../constants.js";
import useAuthenticatedResources from "../../../useAuthenticatedResources.js";

const URL = `${API_HOST_NAME}/api/v1/admin/teams`;

const useTeamsResources = () => {
  return useAuthenticatedResources(URL)
}

export default useTeamsResources;
